/**
 * @prettier
 */

import React, { useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { ButtonV3 } from '@zola/zola-ui/src/components/ButtonV3';
import { BUSINESS_UNIT } from '@zola-helpers/client/dist/es/tracking/onboard/onboardTrackingConstants';
import { getCardCatalogBusy } from '~/cards/selectors/cardCatalogSelector';
import { getMultiSampleState } from '~/cards/selectors/samples';
import { setMultiSampleEnabled as setMultiSampleEnabledAction } from '~/cards/actions/samples';
import MultiSampleBg from '~/assets/images/invitations/single-sample-modal/multi-sample-bg.png';
import MobileMultiSampleBg from '~/assets/images/invitations/single-sample-modal/mobile-multi-sample-bg.jpg';
import { LinkV2 } from '@zola/zola-ui/src/components/LinkV2';
import { trackEvent } from '@zola-helpers/client/dist/es/tracking/trackingHelper';
import styles from './styles.module.less';

const CTA_CLICKED = 'CTA Clicked';

export const PLPTileItem = ({ index, children }) => (
  <div className={styles.plpTileListItem}>
    <div className={styles.plpTileListNumber}>{index}</div>
    <div className={styles.plpTileListText}>{children}</div>
  </div>
);

export const PLPTileBase = ({ cardType, isDesktop }) => {
  const dispatch = useDispatch();
  const plpBusy = useSelector(getCardCatalogBusy);
  const multiSampleState = useSelector(getMultiSampleState);

  const enableSamples = useCallback(() => {
    if (!multiSampleState.enabled) {
      trackEvent(CTA_CLICKED, {
        business_unit: BUSINESS_UNIT.INVITATIONS,
        cta_type: 'BUTTON',
        cta: 'SELECT_YOUR_DESIGNS',
      });
    }
    dispatch(setMultiSampleEnabledAction(cardType, true));
  }, [cardType, multiSampleState.enabled, dispatch]);

  if (plpBusy) {
    return null;
  }

  return (
    <>
      {!isDesktop ? (
        <div className={styles.plpTileBoxNew}>
          <div
            className={styles.plpTileMobileImg}
            style={{ backgroundImage: `url(${MobileMultiSampleBg})` }}
          />
          <div className={styles.plpTileTitleNew}>Get 5 Free Personalized Samples</div>
          {!multiSampleState.enabled && (
            <LinkV2 arrow role="button" className={styles.plpTileLink} onClick={enableSamples}>
              Select Designs
            </LinkV2>
          )}
        </div>
      ) : (
        <div className={styles.plpTileBoxNew} style={{ backgroundImage: `url(${MultiSampleBg})` }}>
          <div className={styles.plpTileTitleNew}>How to get free personalized samples:</div>
          <div className={styles.plpTileListBoxNew}>
            <div className={styles.plpTileListNew}>
              <PLPTileItem index={1}>Choose up to five designs.</PLPTileItem>
              <PLPTileItem index={2}>Add a photo and your details.</PLPTileItem>
              <PLPTileItem index={3}>Get your samples (with free shipping!).</PLPTileItem>
            </div>
          </div>
          {!multiSampleState.enabled && (
            <ButtonV3 variant="primary" onClick={enableSamples}>
              Select your designs
            </ButtonV3>
          )}
        </div>
      )}
    </>
  );
};

export default PLPTileBase;
